var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoGmxDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 86.503,
    height: 21.462,
    viewBox: "0 0 86.503 21.462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.536,
    y1: 0.026,
    x2: 0.011,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03d1cf",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e09f8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_GMX",
    transform: "translate(-32 -17.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M555.182,717.462,540.447,696l-14.78,21.462h20.592l-5.812-8.191-2.883,4.256H534.5l5.949-8.557,8.6,12.493Z",
    transform: "translate(-493.667 -678.026)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M9.216-8.544c-.168,0-.24.072-.24.24v1.44c0,.168.072.24.24.24h4.776V-4.1A5.361,5.361,0,0,1,9.144-1.68c-3.576,0-5.784-2.3-5.784-6.72,0-4.392,2.592-6.72,5.544-6.72,2.3,0,4.176.912,4.776,3.12a.281.281,0,0,0,.288.24H15.5c.168,0,.264-.072.264-.24-.648-3.36-3.528-5.04-6.864-5.04-3.744,0-7.656,2.88-7.656,8.64,0,5.688,3.7,8.64,7.992,8.64a7.468,7.468,0,0,0,6.528-3.456,1.567,1.567,0,0,0,.24-.912V-8.3c0-.168-.072-.24-.24-.24ZM34.128-16.56c0-.168-.072-.24-.24-.24h-2.28a.37.37,0,0,0-.384.24L26.568-5.88,21.912-16.56a.37.37,0,0,0-.384-.24h-2.28c-.168,0-.24.072-.24.24V-.24c0,.168.072.24.24.24h1.536c.168,0,.24-.072.24-.24V-13.656l4.7,10.632a.331.331,0,0,0,.312.216H27.1a.331.331,0,0,0,.312-.216l4.7-10.632V-.24c0,.168.072.24.24.24h1.536c.168,0,.24-.072.24-.24Zm5.232,0c-.168-.216-.168-.24-.336-.24H37.176c-.168,0-.24.12-.168.24l5.088,7.7L36.384-.24c-.072.12,0,.24.168.24h1.8c.168,0,.216-.024.384-.24L43.3-7.1,47.856-.24c.168.216.216.24.384.24h1.8c.168,0,.24-.12.168-.24L44.5-8.856l5.088-7.7c.072-.12,0-.24-.168-.24H47.568c-.168,0-.168.024-.336.24L43.3-10.632Z",
    transform: "translate(68.267 37.105)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGmxDark);
export default __webpack_public_path__ + "static/media/logo_GMX_dark.8b3d2df6d0138d457898113b02e76249.svg";
export { ForwardRef as ReactComponent };